import { Navigate, useLocation } from "react-router-dom";
import { detectBrowserLanguage } from "@/hooks/useLocalePath";
import { languages } from "@/i18n";

const validLangCodes = new Set(languages.map((l) => l.code));

/**
 * Handles two redirect scenarios:
 * 1. Root "/" → auto-detect browser language and redirect to /:lang/
 * 2. Old unprefixed paths like "/features" → redirect to /en/features
 */
export function LanguageRedirect() {
  const { pathname, search, hash } = useLocation();

  if (pathname === "/") {
    // Check localStorage first, then browser language
    const saved = localStorage.getItem("seaventis-lang");
    const lang = saved && validLangCodes.has(saved) ? saved : detectBrowserLanguage();
    return <Navigate to={`/${lang}/`} replace />;
  }

  // Old unprefixed path — redirect to /en/...
  return <Navigate to={`/en${pathname}${search}${hash}`} replace />;
}
